"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscribeOrigin = exports.GET_MATCHES_FAIL = exports.GET_MATCHES_SUCCESS = exports.GET_MATCHES_REQUEST = exports.DELETE_ENTITIES = exports.UPDATE_MATCH = exports.UPDATE_BET = exports.UNSUBSCRIBE_TO_UPDATES = exports.SUBSCRIBE_TO_UPDATES = exports.NAME = void 0;
exports.NAME = 'async';
exports.SUBSCRIBE_TO_UPDATES = "async/SUBSCRIBE_TO_UPDATES";
exports.UNSUBSCRIBE_TO_UPDATES = "async/UNSUBSCRIBE_TO_UPDATES";
exports.UPDATE_BET = "async/UPDATE_BET";
exports.UPDATE_MATCH = "async/UPDATE_MATCH";
exports.DELETE_ENTITIES = "async/DELETE_ENTITIES";
exports.GET_MATCHES_REQUEST = "async/GET_MATCHES:REQUEST";
exports.GET_MATCHES_SUCCESS = "async/GET_MATCHES:SUCCESS";
exports.GET_MATCHES_FAIL = "async/GET_MATCHES:FAIL";
var SubscribeOrigin;
(function (SubscribeOrigin) {
    SubscribeOrigin["Match"] = "match-Match";
    SubscribeOrigin["MatchList"] = "matchList-MatchRow";
    SubscribeOrigin["BetSlipList"] = "betslip-BetslipList";
    SubscribeOrigin["ComponentsOutright"] = "components-Outright";
    SubscribeOrigin["HookUseSidebarMarketList"] = "hook-useSidebarMarketList";
    SubscribeOrigin["ComponentsCommonOutrightsBanner"] = "components-CommonOutrightsBanner";
    SubscribeOrigin["HookUsePromoItemContainer"] = "hook-usePromoItemContainer";
    SubscribeOrigin["CashoutSubscriptionCashoutSportEvents"] = "cashout-SubscriptionCashoutSportEvents";
    SubscribeOrigin["AppOrigin"] = "App";
})(SubscribeOrigin = exports.SubscribeOrigin || (exports.SubscribeOrigin = {}));
//# sourceMappingURL=constants.js.map